module.exports = __webpack_public_path__ + "static/media/five_digits.eb7a995c.svg";